(function() {
	('use strict');

	angular
		.module('app.detailCustomReport')
		.factory('detailCustomReportService', ['$q', '$http', '$rootScope',
		 	function ($q, $http, $rootScope) {
				var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (result) {
                            deferred.reject(result);
                        });

                    return deferred.promise;
                }

                function getDetailCustomReport(report_id, loader) {
                	var url_getDetailCustomReport = $rootScope.apiUrl + 'measure/getDetailCustomReport/' + report_id;
                	return handleRequest(url_getDetailCustomReport, 'GET', null, loader);
                }

                service.getDetailCustomReport = getDetailCustomReport;

                return service;
			}
		])
})();